import { Component, OnInit } from '@angular/core';
import { StudentCoinService } from '@app/infrastructure/core/services/api/student-coin.service';
import { UserStateService } from '@app/infrastructure/core/services/state/user-state.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-coin-purse',
  templateUrl: './coin-purse.component.html',
  styleUrls: ['./coin-purse.component.scss'],
})
export class CoinPurseComponent implements OnInit {
  public get coinPurseObs$(): Observable<number> {
    return this.studentCoinService.coinPurseObs$;
  }

  constructor(
    private studentCoinService: StudentCoinService,
    private userStateService: UserStateService,
  ) {}

  ngOnInit(): void {
    this.studentCoinService.coinPurse =
      this.userStateService.userSession.student.coinPurse;
  }
}
